export const filterLocationTreeBySearchValue = <T extends { name: string; children: T[] }>(
  arr: T[],
  searchValue: string,
): T[] => {
  if (!searchValue) return arr;

  const lowerCaseSearchValue = searchValue.toLowerCase();
  const clonedArray = structuredClone(arr);

  const filterNode = (item: T) => {
    const isSearchValueMatched = item.name?.toLowerCase().includes(lowerCaseSearchValue);

    if (isSearchValueMatched) return true;

    if (item.children) {
      item.children = item.children.filter(filterNode);
      return item.children.length > 0;
    }

    return false;
  };

  return clonedArray.filter(filterNode);
};
